import PropTypes from "prop-types";
import "components/ui/Labels/Label.scss";

function Label({ variant, children }) {

  return (
    <div className={ `label ${ variant && `label--` + variant }` }>
      { children }
    </div>
  )
}

Label.propTypes = {
  variant: PropTypes.string,
}

export default Label;
